import React from "react"
import {
	ComposableMap,
	Geographies,
	Geography,
	ZoomableGroup,
	Marker,
} from "react-simple-maps"
import Typography from "@mui/material/Typography"

import { db } from "../../../firebase/firebase_config"
import { collection, getDocs } from "firebase/firestore"

const geoUrl = "/world_map.json"

class WorldMapTabComponent extends React.Component {
	constructor() {
		super()
		this.state = {
			position: { coordinates: [0, 20], zoom: 1 },
			loading: true,
			markers: {},
		}
	}

	async componentDidMount() {
		const markers_ret = await this.getMarkersData()
		this.setState({ loading: false, markers: markers_ret })
	}

	getMarkersData = async () => {
		let markersList = []
		try {
			const markersCollection = collection(db, "WorldMapMarkers")
			await getDocs(markersCollection).then((snapshot) => {
				snapshot.forEach((doc) => {
					console.log(doc)
					markersList.push({ ...doc.data(), id: doc.id })
				})
			})
		} catch (error) {
			console.log("Error fetching firestore data: " + error.message)
		}
		//console.log(newsList)
		return markersList
	}

	handleMoveEnd(new_position) {
		this.setState({ position: new_position })
	}

	render() {
		const mapWidth = 800
		const mapHeight = 600

		/* Google by default returns coordinates as [lat, lon], while d3-geo specifies them as [lon, lat]. */
		let markersComponents = <div>Adquiring data...</div>

		const markerOffset = -5

		if (!this.state.loading) {
			markersComponents = this.state.markers.map((marker, index) => {
				if (marker.ENABLED) {
					return (
						<Marker
							key={index}
							coordinates={[
								marker.LOCATION.longitude,
								marker.LOCATION.latitude,
							]}
						>
							<circle r={1} fill="#3d8bf2" />
							<text
								textAnchor="left"
								y={markerOffset}
								style={{
									fontFamily: "system-ui",
									fill: "#3d8bf2",
									fontSize: "8",
								}}
							>
								{marker.NAME}
							</text>
						</Marker>
					)
				}
			})
		}

		return (
			<>
				<Typography variant="h3">World Map</Typography>
				<p>Encuentra tu lugar en el mundo para jugar al Hockey Subacuático!</p>
				<ComposableMap
					style={{ width: "100%", maxHeight: "600px" }}
					width={mapWidth}
					height={mapHeight}
					projectionConfig={{ scale: 200 }}
				>
					<ZoomableGroup
						zoom={this.state.position.zoom}
						center={this.state.position.coordinates}
						onMoveEnd={this.handleMoveEnd}
						translateExtent={[
							[0, 0],
							[mapWidth, mapHeight],
						]}
					>
						<Geographies geography={geoUrl}>
							{({ geographies }) =>
								geographies.map((geo) => (
									<Geography key={geo.rsmKey} geography={geo} />
								))
							}
						</Geographies>
						{markersComponents}
					</ZoomableGroup>
				</ComposableMap>
			</>
		)
	}
}

export default WorldMapTabComponent
